// export const url = "https://xtratoys.nextechltd.in/api";
export const url = "https://arihant.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";

// export const url = "http://localhost:8000/api";
export const isAdmin = true;

export const adminUrl = "https://arihant.nextechltd.in/api";
